import React, { useState } from 'react'
import { api } from '../../../services'
import {
  Alert,
  Button,
  Divider,
  Form,
  Icon,
  Input,
  InputNumber,
  Radio,
  Spin
} from 'antd'
import { useTranslation } from 'react-i18next'
import './AiCourseForm.scss'
import SharelookHelpModal from '../../NewHeader/SharelookHelpModal/SharelookHelpModal'

const FormItem = Form.Item
const RadioGroup = Radio.Group
const { TextArea } = Input

const AiCourseForm = ({
  onFormSubmit,
  loading,
  courseTitle = '',
  courseId,
  isFromKnowledgeCenter,
  formValues,
  ...props
}) => {
  const [isStandardRequired, setIsStandardRequired] = useState(false)
  const [isIndustrySpecific, setIsIndustrySpecific] = useState(false)

  const onStandardChange = e => {
    setIsStandardRequired(e.target.value === 'yes')
  }

  const onIndustryChange = e => {
    setIsIndustrySpecific(e.target.value === 'yes')
  }

  const handleSubmit = e => {
    e.preventDefault()
    props.form.validateFields((err, values) => {
      if (!err) {
        onFormSubmit(values)
      }
    })
  }

  const { getFieldDecorator } = props.form
  const { t } = useTranslation()

  return (
    <Spin spinning={loading}>
      {!isFromKnowledgeCenter && (
        <div className="course-creation-ai-modal__header">
          <h2>{t('v3:ai_course_creation')}</h2>
          <SharelookHelpModal />
        </div>
      )}

      <Form
        className="ai-course-form"
        layout="vertical"
        onSubmit={handleSubmit}
      >
        <FormItem label={t('v3:ai_course_title')}>
          {getFieldDecorator('courseTitle', {
            initialValue: formValues?.courseTitle || courseTitle,
            rules: [
              { required: true, message: t('v3:ai_course_title_training') }
            ]
          })(<Input placeholder={t('v3:ai_course_title_training')} />)}
        </FormItem>

        <FormItem label={t('v3:learning_objective_label')}>
          {getFieldDecorator('learningObjective', {
            initialValue: formValues?.learningObjective,
            rules: [
              { required: true, message: t('v3:learning_objective_message') }
            ]
          })(<TextArea placeholder={t('v3:ai_course_object')} />)}
        </FormItem>

        <FormItem label={t('v3:standard_question')}>
          {getFieldDecorator('standard', {
            initialValue: formValues?.standard || 'no'
          })(
            <RadioGroup onChange={onStandardChange}>
              <Radio value="yes">{t('general:yes')}</Radio>
              <Radio value="no">{t('general:no')}</Radio>
            </RadioGroup>
          )}
        </FormItem>

        {(isStandardRequired || formValues?.standard === 'yes') && (
          <FormItem label={t('v3:standard_details_label')}>
            {getFieldDecorator('standardDetails', {
              initialValue: formValues?.standardDetails,
              rules: [
                { required: true, message: t('v3:standard_details_message') }
              ]
            })(<TextArea />)}
          </FormItem>
        )}

        {/* <Divider /> */}

        <FormItem
          className="ai-course-form__duration"
          label={t('v3:estimated_duration_label')}
        >
          {getFieldDecorator('duration', {
            initialValue: formValues?.duration,
            rules: [
              { required: true, message: t('v3:estimated_duration_message') },
              {
                type: 'number',
                min: 5,
                message: t('v3:min_duration_message')
              }
            ]
          })(<InputNumber min={1} placeholder={t('v3:ai_mins')} />)}

          {/* <span></span> */}
        </FormItem>

        {/* <Divider /> */}

        <FormItem label={t('v3:industry_specific_question')}>
          {getFieldDecorator('industrySpecific', {
            initialValue: formValues?.industrySpecific || 'no'
          })(
            <RadioGroup onChange={onIndustryChange}>
              <Radio value="yes">{t('general:yes')}</Radio>
              <Radio value="no">{t('general:no')}</Radio>
            </RadioGroup>
          )}
        </FormItem>

        {(isIndustrySpecific || formValues?.industrySpecific === 'yes') && (
          <FormItem label={t('v3:industry_label')}>
            {getFieldDecorator('industry', {
              initialValue: formValues?.industry,
              rules: [{ required: true, message: t('v3:industry_message') }]
            })(<Input />)}
          </FormItem>
        )}

        {/* <Divider /> */}

        <div className="ai-course-form__submit">
          <FormItem>
            <Button
              size="large"
              shape="round"
              htmlType="submit"
              className="shl-primary-btn"
            >
              {t('buttons:next')} <Icon type="right" />
            </Button>
          </FormItem>
        </div>
        {/* ContentChoiceModal removed, now handled in parent step modal */}
      </Form>
    </Spin>
  )
}

const WrappedAiCourseForm = Form.create({ name: 'ai_course_form' })(
  AiCourseForm
)

export default WrappedAiCourseForm
